






import 'spectre.css';
import App from './App.vm.ts';
export default App;



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue